import { Session } from "../../adapters/session";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(session: Session): Interactor {
  return () => present(session.destroy());
}

export type { Interactor };

export { createInteractor };
